import React from 'react';

const Idgaa = () => {
    return (
        <h1>Идгаачойнзэнлин дацан</h1>
    )
}
export default Idgaa;